import {isHolyday} from "./holidays/WorldHolidays";


export class WeekSchedule {

    static MONDAY = 1;
    static TUESDAY = 2;
    static WEDNESDAY = 4;
    static THURSDAY = 8;
    static FRIDAY = 16;
    static SATURDAY = 32;
    static SUNDAY = 64;


    public static isChecked(day: number, bitSum: number): boolean {
        return (day & bitSum) > 0;
    }

    public static toggle(day: number, bitSum: number): number {
        bitSum ^= day;
        return bitSum;
    }

    public static getBitSumForDay(weekDay: number): number {
        return Math.pow(2, weekDay);
    }

    public static getBitSumForDate(dateYYYYmmdd:string): number {
        if (dateYYYYmmdd==='') {
            alert('getBitSumForDate: dateYYYYmmdd is empty');
        }
        const date = dateYYYYmmdd!=='' ? new Date(dateYYYYmmdd) : new Date();
        if (isHolyday('pl', dateYYYYmmdd) !== null) {
            return this.getBitSumForDay(7);
        } else {
            return this.getBitSumForDay(date.getDay() ? date.getDay() - 1 : 6);
        }
    }

    public static reset(day: number, bitSum: number): number {
        return bitSum & ~day;
    }

    public static getSum(bitSums: number[]): number {
        return bitSums.reduce((acc, bitSum) => acc | bitSum, 0);
    }


}